// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectIndex_root__46-Tq","filter":"ProjectIndex_filter__27ccH","projectArea":"ProjectIndex_projectArea__3oGvl","noContent":"ProjectIndex_noContent__1rJUI"};